import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import SchoolDetail from "./SchoolDetail";
import DashboardLayout from "../../layout/DashboardLayout";
import { SchoolProvider } from "../../context/SchoolContext";
import Home from "../../components/Home"
import Graph from "../../commons/Graph";
import Devicepage from "../Individual/Device";
import Errorpage from "../Individual/Error";
import Individual from "../Individual/Individual";
import Connection from '../Individual/CommMgnt/CommMgnt';
import Setting from "../../commons/Setting";
import NotFound from "../../NotFound";
import RemoteControl from '../Individual/RemoteControl';
import { useState } from "react";
import NoticeSetting from "../../commons/NoticeSetting";

const Homepage = (props) => {

  // const [selected, setSelected] = useState(false);
  let { path } = useRouteMatch();
  const history = useHistory();
  const pathname = history["location"].pathname
  const schoolId = Number(pathname.split('/').pop());
  const [type, setType] = useState('');


  return (
    <SchoolProvider>
      <DashboardLayout setControlType={setType}>
        {/* <Container fluid className="px-5 mt-2" > */}
        <Switch>
          {schoolId === 0 || pathname === `${path}/${schoolId}` ? <Route component={NotFound} /> : <Route exact path={path} component={SchoolDetail} />}
          <Route exact path={`${path}/dashboard/:id`} component={Home} />
          <Route exact path={`${path}/graph/:id`} component={Graph} />
          <Route exact path={`${path}/device/:id`} component={Devicepage} />
          <Route exact path={`${path}/error/:id`} component={Errorpage} />
          <Route exact path={`${path}/individual/:id`} component={Individual} />
          <Route exact path={`${path}/communication/:id`} component={Connection} />
          <Route exact path={`${path}/user`} component={Setting} />
          <Route exact path={`${path}/notice`} component={NoticeSetting} />
          <Route exact path={`${path}/remoteControl/:id`}>
            <RemoteControl controlType={type} />
          </Route>
        </Switch>
        {/* <SchoolDetail /> */}
        {/* </Container > */}
      </DashboardLayout>

    </SchoolProvider >
  );
};

export default Homepage;
